module.exports = __webpack_public_path__ + "img/icon3.7fd4719a.png";